var _title, _desc, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowIcon = function SvgArrowIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "5px",
    viewBox: "0 0 8 5",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uD83C\uDFA8 Icon color")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rangert-Bane---200m---3-5-klasse",
    transform: "translate(-272.000000, -219.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav/Menu/Small",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "State-lvl2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Icon/Caret",
    transform: "translate(272.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87991678,3.71079004 L4.28927508,0.119783588 C4.1294073,-0.0399278627 3.87048195,-0.0399278627 3.71079656,0.119783588 L0.119764048,3.71079004 C-0.0399213492,3.8705536 -0.0399213492,4.1294529 0.119764048,4.28921646 L0.408990282,4.57844269 C0.568675679,4.73831047 0.827835516,4.73831047 0.987625129,4.57844269 L3.99999674,1.56591476 L7.01247256,4.57844269 C7.1721319,4.73831047 7.43116147,4.73831047 7.59089898,4.57844269 L7.88012521,4.28921646 C8.03999299,4.12927052 8.03999299,3.8705536 7.87991678,3.71079004 Z",
    id: "\\uD83C\\uDFA8-Icon-color",
    transform: "translate(4.000000, 2.349172) scale(1, -1) translate(-4.000000, -2.349172) "
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-icon.b8efc16d.svg";
export { ForwardRef as ReactComponent };